import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div id="footer">
            <div className="footer section-container">
                <div className="brand">
                    <h1><span>A</span>vijit <span>R</span>oy</h1>
                </div>
                <h2>Front End Web Developer</h2>
                <div className="social-icon">
                    <div className="social-item">
                        <a href="https://www.facebook.com/ankan.roy.50999/"><i className="fab fa-facebook-f"></i></a>
                    </div>
                    <div className="social-item">
                        <a href="https://www.instagram.com/ankan_782/"><i className="fab fa-instagram"></i></a>
                    </div>
                    <div className="social-item">
                        <a href="https://twitter.com/AvijitAnkan"><i className="fab fa-twitter"></i></a>
                    </div>
                    <div className="social-item">
                        <a href="https://www.linkedin.com/in/avijit-roy-b6428b174/"><i className="fab fa-linkedin-in"></i></a>
                    </div>
                    <div className="social-item">
                        <a href="https://github.com/ankan-782"><i className="fab fa-github"></i></a>
                    </div>
                </div>
                <p>Copyright © 2021 Avijit Roy. All rights reserved</p>
            </div>
        </div>
    );
};

export default Footer;